import type { EventTicketKind } from "@hobbyshopify/backend-client";
import { Rx, RxList } from "subtree.js/core";
import { type FormStatus, idleForm, idleLoad, type LoadStatus } from "../../../../core/primitives/load-status";
import {
  EMPTY_TICKET_KIND,
  type TicketKindDraft,
  type TicketKindErrors,
  type TicketKindField,
} from "../../../../core/primitives/ticket-kind";

/** The kinds of ticket a saved show has for its visitors, and the forms that add and change them. */
export class TicketKindsSectionState {
  readonly status = new Rx<LoadStatus>(idleLoad);
  readonly kinds = new RxList<EventTicketKind>();
  /** A call of the section's is on its way, or the reading after one that failed: nothing else is asked meanwhile. */
  readonly acting = new Rx(false);

  readonly draft = new Rx<TicketKindDraft>(EMPTY_TICKET_KIND);
  readonly errors = new Rx<TicketKindErrors>({});
  readonly addForm = new Rx<FormStatus>(idleForm);

  readonly editingId = new Rx<string | null>(null);
  readonly editDraft = new Rx<TicketKindDraft>(EMPTY_TICKET_KIND);
  readonly editErrors = new Rx<TicketKindErrors>({});
  readonly editForm = new Rx<FormStatus>(idleForm);

  /** A removal in flight, and the sentence when one is refused. */
  readonly removingId = new Rx<string | null>(null);
  readonly removeError = new Rx<string | null>(null);

  /** The show is cancelled: its tickets stay as they are. */
  readonly cancelled = new Rx(false);
}

export abstract class TicketKindsSectionActions {
  abstract setField(field: TicketKindField, value: string): void;
  abstract add(): Promise<void>;
  abstract startEdit(kindId: string): void;
  abstract setEditField(field: TicketKindField, value: string): void;
  abstract saveEdit(): Promise<void>;
  abstract cancelEdit(): void;
  abstract remove(kindId: string): Promise<void>;
}
